import { uuidv7 } from "uuidv7";

export function createAccrualImporterRowId(): string {
    return uuidv7();
}
